
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/admins",
      function () {
        return require("private-next-pages/users/admins/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/admins"])
      });
    }
  